import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilitiesMyDocument, UtilitiesMyDocumentAppCategory, UtilitiesMyDocumentDownload } from '@libs/generated-types/utilities';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../@core/services/environment.service';

@Injectable({
    providedIn: 'root',
})
export class MyDocumentsService {
    private readonly apiUrl: string = '';

    constructor(
        private readonly http: HttpClient,
        private readonly environmentService: EnvironmentService,
    ) {
        // Use environment service to get the API URL
        this.apiUrl = this.environmentService.utilitiesServiceUrl + '/my-documents/app';
    }

    getMyDocumentsCategories(): Observable<UtilitiesMyDocumentAppCategory[]> {
        return this.http.get<UtilitiesMyDocumentAppCategory[]>(this.apiUrl);
    }

    getDocumentsByCategory(categoryCode: string): Observable<UtilitiesMyDocument[]> {
        return this.http.get<UtilitiesMyDocument[]>(`${this.apiUrl}/${categoryCode}/documents`);
    }

    generateDownloadToken(categoryCode: string, documentId: string): Observable<UtilitiesMyDocumentDownload> {
        return this.http.get<UtilitiesMyDocumentDownload>(`${this.apiUrl}/${categoryCode}/documents/${documentId}/downloadUrl`);
    }

    downloadDocument(token: string, filename: string): string {
        return `${this.apiUrl}/download/${token}?filename=${encodeURIComponent(filename)}`;
    }

    getDocumentFile(token: string, filename: string): Observable<File> {
        return this.http.get<File>(`${this.apiUrl}/download/${token}?filename=${encodeURIComponent(filename)}`, { responseType: 'blob' as 'json' });
    }

    logNotes(documentId: string, categoryCode: string): Observable<void> {
        return this.http.put<void>(`${this.apiUrl}/${categoryCode}/documents/${documentId}/notes/read`, {});
    }

    validateToken(token: string): Promise<boolean> {
        return new Promise((resolve) => {
            fetch(this.apiUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'it',
                    'Authorization': `Bearer ${token}`,
                }
            })
                .then(response => {
                    if (response.ok) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                })
                .catch(() => {
                    resolve(false);
                });
            // this.http.get<boolean>(this.apiAppUrl + '/validate-token', { params: { token } }).subscribe({
            //   next: (res) => {
            //     resolve(res);
            //   },
            //   error: (err) => {
            //     resolve(false);
            //   },
            // });

        });
    }
}
